var map = {
	"./account/index.routes.js": "./src/view/account/index.routes.js",
	"./home/index.routes.js": "./src/view/home/index.routes.js",
	"./organization/index.routes.js": "./src/view/organization/index.routes.js",
	"./report/index.routes.js": "./src/view/report/index.routes.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/view sync recursive \\.routes\\.js";